
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"73.846","height":"24","viewBox":"0 0 80 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_381_372)"}},[_c('path',{attrs:{"d":"M52.095.04c-5.675 0-10.746 2.941-10.746 8.375 0 6.233 8.994 6.663 8.994 9.794 0 1.318-1.51 2.498-4.091 2.498-3.662 0-6.399-1.649-6.399-1.649l-1.17 5.484s3.152 1.393 7.338 1.393c6.204 0 11.086-3.086 11.086-8.613 0-6.585-9.031-7.003-9.031-9.909 0-1.033 1.24-2.164 3.813-2.164 2.903 0 5.271 1.2 5.271 1.2l1.146-5.297S55.73.04 52.095.04zM.177.44l-.137.8s2.387.436 4.538 1.308c2.768 1 2.965 1.58 3.432 3.388l5.08 19.587h6.811L30.394.44H23.6l-6.742 17.054-2.752-14.456C13.853 1.383 12.575.44 11.011.44H.177zm32.95 0l-5.331 25.082h6.48L39.588.44h-6.461zm36.14 0c-1.562 0-2.39.836-2.998 2.298l-9.493 22.785h6.795l1.315-3.798h8.279l.8 3.797h5.995L74.73.44h-5.463zm.884 6.776l2.014 9.413H66.77l3.382-9.413z","fill":"#1434CB"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_381_372"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h80v25.975H0z"}})])])])
          )
        }
      }
    